import Router from './pages/router/Router';
const App = () => {
	return <Router />;
};

export default App;
